import React from 'react';
import type { FC } from 'react';
import { VersionListProvider } from '../VersionListProvider';
import { VersionsTable } from '../VersionsTable';
import { Stack, Typography } from '@mui/material';

export const AvailableVersions: FC = () => {
  return (
    <VersionListProvider>
      <Stack direction='column' spacing={2}>
        <Typography variant='h5'>Available Versions</Typography>
        <VersionsTable />
      </Stack>
    </VersionListProvider>
  );
};
